import type { CampaignTypeInterface } from '@/interfaces/Campaign.interface';

export const CAMPAIGN_TYPE_NAME_EMAIL = 'Email';

export const CAMPAIGN_TYPE_NAME_WHATSAPP = 'WhatsApp';

export const CAMPAIGN_TYPE_NAME_SMS = 'SMS';

export function isEmailCampaignType(
  type: CampaignTypeInterface | null | undefined
): boolean {
  return type?.name === CAMPAIGN_TYPE_NAME_EMAIL;
}

export function isWhatsAppCampaignType(
  type: CampaignTypeInterface | null | undefined
): boolean {
  return type?.name === CAMPAIGN_TYPE_NAME_WHATSAPP;
}

export function isSmsCampaignType(
  type: CampaignTypeInterface | null | undefined
): boolean {
  return type?.name === CAMPAIGN_TYPE_NAME_SMS;
}

export function isMessagingCampaignType(
  type: CampaignTypeInterface | null | undefined
): boolean {
  return isWhatsAppCampaignType(type) || isSmsCampaignType(type);
}
